module.exports = __webpack_public_path__ + "img/people--white.ac3cfacd.svg";